<template>
  <div class="events">
    <Technologies />
    <Frontend />
    <Backend />
    <Mobile />
  </div>
</template>

<script>
import Technologies from "../components/portfolio/Technologies.vue";
// import Technologies from "../components/portfolio/Landing.vue";

import Frontend from "../components/portfolio/Frontend.vue";
import Backend from "../components/portfolio/Backend.vue";
import Mobile from "../components/portfolio/Mobile.vue";
// @ is an alias to /src
import { computed, reactive } from "vue";
import { useHead } from "@vueuse/head";

export default {
  name: "Events",
  components: { Technologies, Frontend, Backend, Mobile },
  setup() {
    const siteData = reactive({
      title: `Barakadev | technologies`,
      description: `My beautiful website`,
    });

    useHead({
      // Can be static or computed
      title: computed(() => siteData.title),
      meta: [
        {
          name: `description`,
          content: computed(() => siteData.description),
        },
      ],
    });
  },
};
</script>
<style>
.events {
  margin-top: 1px;
  min-height: 100vh;

  margin-bottom: 55px;
}
</style>
